(function () {
  /* --- Progress bar update (hardcoded 3-tier, !important to beat theme resets) --- */
  var BAR_MAX = 3;

  function updateProgressBar() {
    var checked = document.querySelectorAll('[name="ctl-addon"]:checked').length;
    var pct = Math.min(Math.round((checked / BAR_MAX) * 100), 100);

    var fill = document.getElementById('ctl-bar-fill');
    var msg = document.getElementById('ctl-bar-msg');

    if (!fill || !msg) return;

    var colour = checked >= BAR_MAX ? '#C9A96E' : '#F8BACA';

    fill.style.cssText = 'display:block !important;' +
      'position:absolute !important;' +
      'top:0 !important;left:0 !important;' +
      'width:' + pct + '% !important;' +
      'height:100% !important;' +
      'background:' + colour + ' !important;' +
      'border-radius:6px !important;' +
      'transition:width 0.3s ease, background 0.3s ease !important;';

    if (checked === 0) {
      msg.innerHTML = 'Add <strong>1 piece of jewellery</strong> to unlock <strong>10% off  </strong>';
    } else if (checked === 1) {
      msg.innerHTML = 'Add <strong>1 more piece</strong> to save <strong>20%</strong>';
    } else if (checked === 2) {
      msg.innerHTML = 'Add <strong>1 more piece</strong> to save <strong>30%</strong>';
    } else {
      msg.innerHTML = '<strong>30% off applied</strong> — nice stack ✦';
    }
  }

  /* --- Toggle checked class on cards + update progress --- */
  document.querySelectorAll('[data-ctl-block] .ctl-block__checkbox').forEach(function (cb) {
    cb.addEventListener('change', function () {
      cb.closest('.ctl-block__card').classList.toggle('ctl-block__card--checked', cb.checked);
      updateProgressBar();
    });
  });

  /* --- Initialise progress bar on load --- */
  updateProgressBar();

  /* --- Intercept Add to Cart when add-ons are checked --- */
  var productFormEl = document.querySelector('product-form');
  if (!productFormEl) return;
  var form = productFormEl.querySelector('form');
  if (!form) return;

  form.addEventListener('submit', function (event) {
    var checked = document.querySelectorAll('input[name="ctl-addon"]:checked');
    if (checked.length === 0) return;

    event.preventDefault();

    /* Replicate the selling-plan validation from ProductForm */
    var purchaseOptions = document.querySelector('purchase-options');
    if (
      purchaseOptions &&
      typeof purchaseOptions.isOneTimePurchase === 'function' &&
      !purchaseOptions.isOneTimePurchase() &&
      !productFormEl.hasAttribute('data-has-selling-plan')
    ) {
      purchaseOptions.showError();
      return;
    }

    var submitBtn = form.querySelector('[name="add"]');

    /* --- Get variant ID from product-selector's currentVariant (source of truth) --- */
    var ps = document.querySelector('product-selector');
    var variantId = ps && ps.currentVariant ? ps.currentVariant.id : NaN;

    /* Fallback: URL ?variant= param */
    if (!variantId || isNaN(variantId)) {
      variantId = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
    }

    if (!variantId || isNaN(variantId)) return;

    event.stopImmediatePropagation();

    /* Read quantity from the form (defaults to 1 if hidden/absent) */
    var qtyInput = form.querySelector('[name="quantity"]');
    var mainQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var items = [{ id: variantId, quantity: mainQty }];
    checked.forEach(function (cb) {
      items.push({ id: Number(cb.value), quantity: 1 });
    });

    submitBtn.classList.add('disabled');

    var cartDrawer = document.querySelector('cart-drawer');
    var sections = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sections = cartDrawer.getSectionsToRender().map(function (s) { return s.section; });
    }

    var httpOk;

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        httpOk = r.ok;
        return r.json();
      })
      .then(function (response) {
        if (!httpOk || response.status) {
          if (typeof productFormEl.handleErrorMessage === 'function') {
            productFormEl.handleErrorMessage(
              response.description || response.message || 'Could not add items to cart'
            );
          }
          return;
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        submitBtn.classList.remove('disabled');
      });
  }, true); /* capture phase — fires before ProductForm's bubble listener */
})();
